import cookie from 'js-cookie'
import store from '@store'

function resetCookies() {
    const { cookies } = store.state.modeling
    const storeToken = cookies.passport
    const cookieToken = cookie.get('passport')
    const isDiffident = cookieToken !== storeToken
    if (storeToken && isDiffident) {
        cookie.set('passport', storeToken)
    }
}

export default resetCookies
